/**
 *
 * Checks for updates to service worker
 *
 */
export default ({ store }) => {
    store.dispatch('checkServiceWorkerUpdated');
};
